export const services = [
  {
    id: "gbp",
    title: "Google Business Profile Setup",
    description: "Get listed and found on Google.",
    items: [
      "Profile creation & verification",
      "Category optimization",
      "Hours, contact & description",
      "Photos, services & FAQ",
    ],
  },
  {
    id: "maps",
    title: "Google Maps Optimization",
    description: "Help customers find accurate location and business information.",
    items: [
      "Location accuracy",
      "Info & photo updates",
      "Attribute updates",
      "Ongoing optimization",
    ],
  },
  {
    id: "website-builder",
    title: "Website Builder",
    description: "Professional websites for local businesses.",
    items: [
      "Mobile responsive",
      "Contact form & maps",
      "Product gallery",
      "WhatsApp & call buttons",
    ],
  },
];
